import Content from "components/Content";
import Label from "components/Label";
import text from "constants/text";
import React, { FC } from "react";

import styles from "./styles.module.scss";

const ThePromise: FC = () => {
  const { title, description, includes } = text.vendors.the_promise;

  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label className={styles.title} color="lightPrimary" variant="h-centered">
        {title}
      </Label>
      <Label
        className={styles.description}
        color="lightPrimary"
        variant="s-centered"
      >
        {description}
      </Label>
      <div className={styles.items}>
        {includes.map((item) => (
          <div className={styles.item}>
            <Label
              className={styles.itemTitle}
              color="primary"
              variant="bold-s"
            >
              {item.title}
            </Label>
            <Label
              className={styles.itemDescription}
              color="primary"
              variant="s"
            >
              {item.description}
            </Label>
          </div>
        ))}
      </div>
    </Content>
  );
};

export default ThePromise;
